import { __assign, __extends } from "tslib";
import React from 'react';
import MediaSelector from '../../MediaSelector/';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import { DeviationResourceType } from '../../../types/deviation';
import innerMediaSelectorStyles from './InnerMediaSelector.scss';
var InnerMediaSelector = /** @class */ (function (_super) {
    __extends(InnerMediaSelector, _super);
    function InnerMediaSelector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InnerMediaSelector.prototype.render = function () {
        var _a;
        var _b = this.props, currentMediaSource = _b.currentMediaSource, mediaSourceTypes = _b.mediaSourceTypes, selectionLimit = _b.selectionLimit, withMediaSourceSelector = _b.withMediaSourceSelector, allowedDeviationTypes = _b.allowedDeviationTypes, allowedDeviationResourceTypes = _b.allowedDeviationResourceTypes, allowGifs = _b.allowGifs, allowInTierContent = _b.allowInTierContent, ignoreDeviationIds = _b.ignoreDeviationIds, onSelect = _b.onSelect, onClose = _b.onClose, title = _b.title, submitBtnLabel = _b.submitBtnLabel;
        return (React.createElement(MediaSelector, __assign({ initialMediaSource: currentMediaSource, mediaSourceTypes: mediaSourceTypes, withMediaSourceSelector: withMediaSourceSelector, allowedDeviationTypes: allowedDeviationTypes, allowedDeviationResourceTypes: allowedDeviationResourceTypes, allowGifs: allowGifs, allowInTierContent: (currentMediaSource &&
                [
                    MediaSourceType.TIER_DEVIATIONS,
                    MediaSourceType.TIER_POSTS,
                ].includes(currentMediaSource)) ||
                allowInTierContent, ignoreDeviationIds: ignoreDeviationIds, selectionLimit: selectionLimit, overlayClassName: innerMediaSelectorStyles['add-deviations-overlay'], onSelect: onSelect, onClose: onClose, title: title, submitBtnLabel: submitBtnLabel }, (_a = {},
            _a[MediaSourceType.CUSTOM_SET] = {
                withMediaSourceSelector: true,
                initialMediaSource: mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : mediaSourceTypes[0],
            },
            _a[MediaSourceType.TIER_DEVIATIONS] = {
                initialMediaSource: MediaSourceType.GALLERY,
                mediaSourceTypes: [
                    MediaSourceType.GALLERY,
                    MediaSourceType.TIER_DEVIATIONS,
                ],
                withMediaSourceSelector: true,
                allowUploads: false,
            },
            _a[MediaSourceType.TIER_POSTS] = {
                initialMediaSource: MediaSourceType.POSTS,
                mediaSourceTypes: [
                    MediaSourceType.POSTS,
                    MediaSourceType.TIER_POSTS,
                ],
                allowedDeviationResourceTypes: [
                    DeviationResourceType.JOURNAL,
                    DeviationResourceType.STATUS_DEVIATION,
                ],
                withMediaSourceSelector: true,
                allowUploads: false,
            },
            _a)[currentMediaSource !== null && currentMediaSource !== void 0 ? currentMediaSource : ''])));
    };
    return InnerMediaSelector;
}(React.Component));
export default withCurrentMediaSource(InnerMediaSelector);
//# sourceMappingURL=InnerMediaSelector.connected.js.map